/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;min-height:120px;align-items:center}section[_ngcontent-%COMP%]{width:100%}.content[_ngcontent-%COMP%]   .font-weight-bold[_ngcontent-%COMP%]{font-size:.975rem;text-transform:uppercase}"];
export { styles as styles };
